import { gql } from "@apollo/client";
import { useResettableMutation } from "../useResettableMutation";
import { getErrors } from "../../utils/apolloError";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { SubmitPermitToDig, SubmitPermitToDigVariables } from "./__generated__/SubmitPermitToDig";

const SUBMIT_PERMIT = gql`
  mutation SubmitPermitToDig(
    $id: String
    $permitDataInput: PermitDataInput
    $number: Int!
    $permitRegisterId: String!
    $sourceId: String
    $documentIds: [String!]
    $calibrationCertificate: CalibrationCertificateInput
    $asBuiltRequired: Boolean!
    $areas: [AreaInput!]
    $permitAssignmentInputs: [PermitAssignmentInput!]
    $sitePhotos: [SitePhotoInput]
    $sitePhotoIds: [String]
    $permitTypeId: String
    $fieldValues: [PermitFieldValueInput]
  ) {
    submitPermitToDig(
      input: {
        id: $id
        permitDataInput: $permitDataInput
        number: $number
        permitRegisterId: $permitRegisterId
        sourceId: $sourceId
        documentIds: $documentIds
        calibrationCertificate: $calibrationCertificate
        asBuiltRequired: $asBuiltRequired
        areas: $areas
        permitAssignmentInputs: $permitAssignmentInputs
        sitePhotos: $sitePhotos
        sitePhotoIds: $sitePhotoIds
        permitTypeId: $permitTypeId
        fieldValues: $fieldValues
      }
    ) {
      permitToDig {
        id
      }
    }
  }
`;

export function useSubmitPermit() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    SubmitPermitToDig,
    SubmitPermitToDigVariables
  >(SUBMIT_PERMIT, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
